import { api } from '@/api'

export default {
  getPaymentMethod: () => api.$get('/payment_methods'),
  getReceivePaymentMethod: () => api.$get('/receive_payment_methods')
}
